import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 18 21.81"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M17.69 8.74c-.4.36-1.04.36-1.45 0l-6.2-5.53v17.64c0 .53-.47.95-1.04.95s-1.04-.43-1.04-.95V3.21l-6.2 5.53c-.41.36-1.04.36-1.45 0A.9.9 0 0 1 0 8.06c0-.26.11-.5.31-.68L8.28.27s.07-.05.12-.08c.06-.04.13-.09.22-.12.13-.05.26-.07.39-.07s.26.02.39.07c.09.03.16.08.24.14.02 0 .08.05.1.06l7.96 7.11c.2.18.31.42.31.68s-.11.5-.31.68Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }